import { Tooltip, Button, colors } from '@insurancemenu/imenu-components-lib';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import { Download, DriveFile } from '@insurancemenu/imenu-components-lib/dist/icons';
import { AlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { PRODUCT_LINES_CONTENT_MAP } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import ActionModal from 'components/common/modals/ActionModal';
import React from 'react';
import { downloadByUrl } from '@insurancemenu/imenu-components-lib/dist/helpers/downloadByUrl';
import { createStyles } from './styles';
import { EnrollmentPeriod } from '../../../types/enrollmentService';

export interface RenewalExhibitsModalProps {
  show: boolean;
  inactivePeriods: EnrollmentPeriod[];
  onClose: () => void;
}

const RenewalExhibitsModal = ({ show, onClose, inactivePeriods }: RenewalExhibitsModalProps): JSX.Element => {
  const classes = createStyles();

  const onDownload = (exhibitUrls: string[]): void => {
    exhibitUrls.forEach((url) => {
      downloadByUrl(url);
    });
  };

  const ExhibitsList = inactivePeriods.map(({ effectiveDate, installedProposal }) => {
    const productLines =
      installedProposal?.productLines.map((installedPLine, index) => {
        const productLineMapObject = PRODUCT_LINES_CONTENT_MAP[installedPLine.id];
        const exhibitName = `${productLineMapObject.label} Exhibit ${index + 1}`;

        const downloadExhibits = (): void => {
          onDownload(installedPLine.exhibitUrls);
        };

        return (
          <li
            key={`${effectiveDate}_${installedPLine.id}`}
            className={classes.fileItem}
            role="menuitem"
            tabIndex={0}
            onClick={downloadExhibits}
            onKeyDown={downloadExhibits}
          >
            <div className={classes.fileInfo}>
              {productLineMapObject.icon('2.5rem')}
              <span>{exhibitName}</span>
            </div>
            <Tooltip alignment={AlignmentTypes.LEFT_CENTER} label="Download exhibit file">
              <Button type="icon" color="primary">
                <Download width="2.4rem" />
              </Button>
            </Tooltip>
          </li>
        );
      }) || [];

    return (
      <React.Fragment key={`${effectiveDate}_periodSection`}>
        {productLines.length > 0 ? (
          <section>
            <h3 className={classes.sectionTitle}>{`Renewed On: ${
              effectiveDate ? normDateToShortAmericanDate(effectiveDate) : ''
            }`}</h3>
            <ul className={classes.productLineFilesList}>{productLines}</ul>
          </section>
        ) : (
          <></>
        )}
      </React.Fragment>
    );
  });

  return (
    <ActionModal
      show={show}
      title="Renewal Exhibits"
      subtitle="Download Renewal Exhibit files"
      modalContent={<div className={classes.periodSections}>{ExhibitsList}</div>}
      onClose={onClose}
      icon={<DriveFile width="5.6rem" color={colors.green[600]} />}
    />
  );
};

export default RenewalExhibitsModal;
